import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import {
  Container,
  Row,
  Col
} from "reactstrap";
import XIcon from '@mui/icons-material/X';
function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#0f172a",
        color: "#e2e8f0",
        marginTop: "60px",
      }}
    >
      <Container   className="py-5">
        <Row className="gy-4">

          {/* Company Info */}
          <Col lg="4" md="6">
            <h4 className="fw-bold text-white mb-3">
              PriceWorth™
            </h4>

            <p
              style={{
                color: "#cbd5e1",
                lineHeight: "1.8",
                fontSize: "15px",
              }}
            >
              <strong>PriceWorth</strong> is a brand of{" "}
              <strong>Wocons Private Limited</strong>.
              <br />
              We help people save money by joining together and
              purchasing premium courses, certifications, and
              learning programs at negotiated group prices.
            </p>

              <div className="mt-2">
              <h6 className="text-white mb-3">
                Follow us on
              </h6>

              <div className="d-flex align-items-center gap-3 flex-wrap">

                <a
                  href="https://www.facebook.com/priceworthgroup/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1", fontSize: "22px" }}
                  title="Facebook"
                >
                  <FaFacebookF />
                </a>

                <a
                  href="https://www.instagram.com/priceworthgroup/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1", fontSize: "22px" }}
                  title="Instagram"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://x.com/priceworthgroup"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1", fontSize: "22px" }}
                  title="X (Twitter)"
                >
                  <XIcon />
                </a>

                <a
                  href="https://www.youtube.com/@priceworth"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1", fontSize: "22px" }}
                  title="YouTube"
                >
                  <FaYoutube />
                </a>

                <a
                  href="https://www.linkedin.com/company/priceworth"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1", fontSize: "22px" }}
                  title="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>

              </div>


            </div>
          </Col>

          {/* Company Details */}
          <Col lg="4" md="6">
            <h5 className="text-white mb-3">
              Company Information
            </h5>

            <ul
              className="list-unstyled"
              style={{ lineHeight: "2" }}
            >
              <li>
                <strong>Business:</strong> Wocons Private Limited
              </li>

              <li>
                <strong>Brand:</strong> PriceWorth
              </li>

              <li>
                <strong>CIN:</strong> [U72900KA2022PTC163725]
              </li>

              <li>
                <strong>GSTIN:</strong> [29AADCW3156F1Z8]
              </li>

              <li>
                <strong>Registered Office:</strong>
                <br />
                Bangalore, Karnataka, India
              </li>
            </ul>
          </Col>

          {/* Contact */}
          <Col lg="4" md="12">
            <h5 className="text-white mb-3">
              Contact
            </h5>

            <ul
              className="list-unstyled"
              style={{ lineHeight: "2" }}
            >
              <li>
                📧{" "}
                <a
                  href="mailto:support@priceworth.com"
                  className="text-decoration-none"
                  style={{ color: "#38bdf8" }}
                >
                  support@priceworth.com
                </a>
              </li>

              <li>
                🌐{" "}
                <a
                  href="https://priceworth.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#38bdf8" }}
                >
                  https://priceworth.com
                </a>
              </li>
              <li>
                🌐{" "}
                <a
                  href="https://wocons.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#38bdf8" }}
                >
                  https://wocons.com
                </a>
              </li>
            </ul>

            <div className="mt-4">
              <h6 className="text-white mb-3">
                Quick Links
              </h6>

              <div className="d-flex flex-wrap gap-3">
                <a
                  href="/about"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1" }}
                >
                  About
                </a>


                <a
                  href="/contact"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1" }}
                >
                  Contact
                </a>

                <a
                  href="/privacy-policy"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1" }}
                >
                  Privacy Policy
                </a>

                <a
                  href="/terms-and-conditions"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1" }}
                >
                  Terms
                </a>

                <a
                  href="/refund-policy"
                  className="text-decoration-none"
                  style={{ color: "#cbd5e1" }}
                >
                  Refund Policy
                </a>
              </div>
            </div>
          </Col>

         

        </Row>

        {/* Divider */}
        <hr
          style={{
            borderColor: "#334155",
            marginTop: "40px",
            marginBottom: "20px",
          }}
        />

        {/* Bottom */}
        <Row className="align-items-center">
          <Col md="6" className="text-center text-md-start mb-2 mb-md-0">
            <small style={{ color: "#94a3b8" }}>
              © {year} Wocons Private Limited. All Rights Reserved.
            </small>
          </Col>

          {/* <Col md="6" className="text-center text-md-end">
            <small style={{ color: "#94a3b8" }}>
              Secure payments powered by Razorpay.
            </small>
          </Col> */}
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;